module.exports = __webpack_public_path__ + "img/new-transaction-user.769cc412.png";